import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import { Link } from "react-router-dom";
import { CrumbTitle } from "./CrumbTitles";

const useStyles = makeStyles((theme) => ({
  link: {
    textDecoration: "none",
    color: "black",
  },
  activeLink: {
    textDecoration: "none",
    color: theme.palette.primary.main,
    cursor: "pointer",
  },
}));

export default function Breadcrumb({
  customTitleSelector,
  basePath = "",
}: {
  customTitleSelector?: (path: string, index: number, pathArr: string[]) => string | undefined;
  basePath?: string;
}) {
  const classes = useStyles();
  const pathname = window.location.pathname;
  const pathArr = pathname.split("/");

  const handlePath = (index: number) => {
    let retVal = "";
    for (let x = 1; x <= index; x++) {
      retVal += "/" + pathArr[x];
    }
    return basePath + retVal;
  };

  const getTitleForCrumb = (path: string, index: number) => {
    if (customTitleSelector) {
      const customTitle = customTitleSelector(path, index, pathArr);
      if (customTitle) {
        return customTitle;
      }
    }
    return CrumbTitle(path);
  };

  return (
    <Breadcrumbs>
      {pathArr.map((path, index) =>
        index !== 0 ? (
          index !== pathArr.length - 1 ? (
            <Link className={classes.link} to={() => handlePath(index)} key={index}>
              {getTitleForCrumb(path, index)}
            </Link>
          ) : (
            <span className={classes.activeLink} key={index}>
              {getTitleForCrumb(path, index)}
            </span>
          )
        ) : null,
      )}
    </Breadcrumbs>
  );
}
